import { Injectable } from '@angular/core';
import { CountryAdminUrl } from "./authorizationCountryAdmin";
import { groupAdminUrl } from "./authorizationGroupAdmin";
import { institutionUserUrl } from "./authorizationInstitutionUser";
import { institutionAdminUrl } from "./authorizationInstitutionAdmin";
import { superAdminUrl } from "./authorizationSuperAdmin";

@Injectable({
  providedIn: 'root'
})
export class AppAuthorization {

  isAuthorization(roleId,path,router){
    var userUrl;

    switch (roleId) {
      case 1: userUrl = superAdminUrl; break;
      case 2: userUrl = CountryAdminUrl; break;
      case 3: userUrl = groupAdminUrl; break;
      case 4: userUrl = institutionAdminUrl; break;
      default: userUrl = institutionUserUrl; break;
    }
    if(userUrl.indexOf(path) < 0) {
      router.navigate(['401']);
      return false;
    } else {
      return true;
    }
  }
}
